module.exports = __webpack_public_path__ + "components/home-header/static/header-6--small-282f6245a8c150b9fc76b5486566f270.jpg";